import { Reveal, Overline } from "@/components/public/Reveal";
import Seo from "@/components/Seo";

export default function Confidentialite() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo title="Politique de confidentialité" path="/politique-de-confidentialite" description="Politique de confidentialité et protection des données personnelles (RGPD) d'Acanthe Jardins." />
      <article className="max-w-3xl mx-auto px-6 md:px-12">
        <Overline>Protection des données</Overline>
        <h1 className="mt-3 font-display text-4xl lg:text-5xl text-forest">Politique de confidentialité</h1>
        <div className="mt-10 prose-acanthe" data-testid="politique-confidentialite">
          <p>Acanthe Jardins accorde une grande importance à la protection de vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi « Informatique et Libertés ».</p>

          <h2>Données collectées</h2>
          <p>Nous collectons uniquement les données que vous nous transmettez volontairement via nos formulaires de contact et de demande de devis, ou via notre assistant de discussion : nom, prénom, téléphone, adresse email, ville, ainsi que les informations relatives à votre projet.</p>

          <h2>Finalité du traitement</h2>
          <ul>
            <li>Répondre à vos demandes de devis, de rappel et de renseignements ;</li>
            <li>Assurer le suivi de la relation commerciale ;</li>
            <li>Améliorer nos services et l'expérience de navigation.</li>
          </ul>

          <h2>Base légale</h2>
          <p>Le traitement de vos données repose sur votre consentement et sur l'intérêt légitime d'Acanthe Jardins à traiter vos demandes.</p>

          <h2>Durée de conservation</h2>
          <p>Vos données sont conservées pour la durée nécessaire au traitement de votre demande et à la relation commerciale, puis archivées ou supprimées conformément aux obligations légales.</p>

          <h2>Destinataires</h2>
          <p>Vos données sont destinées exclusivement aux équipes d'Acanthe Jardins et ne sont ni vendues ni cédées à des tiers à des fins commerciales.</p>

          <h2>Vos droits</h2>
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Vous pouvez exercer ces droits en nous contactant à l'adresse <strong>contact@acanthejardins.fr</strong>. Vous pouvez également introduire une réclamation auprès de la CNIL.</p>

          <h2>Cookies</h2>
          <p>Ce site utilise des cookies et des mesures d'audience internes afin d'analyser la fréquentation et d'améliorer votre expérience. Vous pouvez configurer votre navigateur pour refuser les cookies ; certaines fonctionnalités pourraient alors être limitées.</p>

          <h2>Contact</h2>
          <p>Pour toute question relative à la protection de vos données personnelles : <strong>contact@acanthejardins.fr</strong> — 04 42 69 02 13.</p>
        </div>
      </article>
    </div>
  );
}
